import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import * as wActs from "../actions/website-actions";

class SeoPage extends Component {

  componentDidMount() {

  }

  render() {
    return (
      <div className="main-content left">
        <SeoHeaders Position={"Top"}/>
        <div className="white-box default-content">
          <div className="row">
            {!wActs.isNullOrEmpty(this.props.MainContent) &&
              <div className="blog-white" dangerouslySetInnerHTML={{__html: this.props.MainContent}}></div>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(SeoPage);
